import Nav from "../general/nav.jsx";
import HeroImg from "../../assets/img/Service/Service-Hero.png";
import { useTranslation } from "react-i18next";
import { useLayoutEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function Hero() {
  const { t } = useTranslation();
  const containerRef = useRef(null);
  const title1Ref = useRef(null);
  const title2Ref = useRef(null);
  const imageRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      // Animation pour le premier titre (arrive de la gauche)
      gsap.fromTo(
        title1Ref.current,
        { x: -100, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: containerRef.current,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );

      // Animation pour l'image (fade in)
      gsap.fromTo(
        imageRef.current,
        { opacity: 0 },
        {
          opacity: 1,
          duration: 1,
          delay: 0.2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: containerRef.current,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );

      // Animation pour le deuxième titre (arrive de la droite)
      gsap.fromTo(
        title2Ref.current,
        { x: 100, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 1,
          delay: 0.4,
          ease: "power2.out",
          scrollTrigger: {
            trigger: containerRef.current,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <>
      <Nav />
      <div className="Services-hero" ref={containerRef}>
        <h1 className="Services-hero-Title1" ref={title1Ref}>
          {t("servicesHero.title1")}
        </h1>
        <img ref={imageRef} src={HeroImg} alt="Services" />
        <h1 className="Services-hero-Title2" ref={title2Ref}>
          {t("servicesHero.title2")}
        </h1>
      </div>
    </>
  );
}
